(function () {
  // prevent double init (theme editor / section re-render)
  if (window.__mmClpFixInit) return;
  window.__mmClpFixInit = true;

  function initPriceRanges() {
    document.querySelectorAll('.facets__display.range-slider, .range-slider').forEach(function(root){
      if (root.dataset.mmRangeFix === '1') return;
      root.dataset.mmRangeFix = '1';

      var ranges = root.querySelectorAll('.input-price-range input[type="range"]');
      var nums   = root.querySelectorAll('price-range input[type="number"], .facets__price input[type="number"]');

      if (!ranges || ranges.length < 2) return;
      if (!nums || nums.length < 2) return;

      function sync() {
        var a = parseFloat(ranges[0].value || '0');
        var b = parseFloat(ranges[1].value || '0');
        if (a > b) { var t = a; a = b; b = t; }

        // Keep values in boxes updated
        nums[0].value = a;
        nums[1].value = b;
      }

      ranges[0].addEventListener('input', sync);
      ranges[1].addEventListener('input', sync);
      sync();
    });
  }

  // Run now + after ajax changes
  document.addEventListener('DOMContentLoaded', initPriceRanges);
  initPriceRanges();

  // If your theme reloads filters/products via ajax, re-init safely
  document.addEventListener('shopify:section:load', initPriceRanges);
  document.addEventListener('shopify:section:reorder', initPriceRanges);
})();
